import callDefs from './callDefs'
import { netDialApi } from './netDialAPI'
import { klCnsAPI } from './klCnsAPI'
import { store } from '../../store/store'
import util from '../index'
import eventBus from '@/event_bus'
import callServer from '@/store/modules/call/callServer'
import callStatus from '@/store/modules/call/callStatus'
import logReport from '@/util/logReport'

function getLocalStorage () {
  return JSON.parse(localStorage.getItem('call-details-info'))
}

function isKT () {
  const loginToken = util.parseLoginToken()
  if (!loginToken) { return callServer.state.callMode === 'KT' }
  return (loginToken.callServerType && loginToken.callServerType.indexOf('KT') > -1)
}

function execModule (func, args) {
  if (args) {
    isKT() ? klCnsAPI[func](args) : netDialApi[func](args)
  } else {
    isKT() ? klCnsAPI[func]() : netDialApi[func]()
  }
}
const common = {
  setLocalStorage: (callInfo) => {
    localStorage.setItem('call-details-info', JSON.stringify(callInfo))
  },
  /*****************************************************************************
   * FUNCTON NAME : w2api_button_state()
   * DESCRIPTION  : 상태에 따라서 버튼 활성화 값 변경
   * INPUT        :
   * OUTPUT       :
   *****************************************************************************/
  buttonState: (state) => {
    var login = false
    var logout = false
    var makeCall = false
    var answer = false
    var hold = false
    var retrieve = false
    var consult = false
    var transfer = false
    var conference = false
    var reconnect = false
    var notReady = false
    var ready = false
    var disconnect = false
    var reserve = false
    var sendMessage = false

    if (state === callDefs.STATE_LOGOUT) {
      login = false
      logout = true
      makeCall = true
      answer = true
      hold = true
      retrieve = true
      consult = true
      transfer = true
      conference = true
      reconnect = true
      notReady = true
      ready = true
      disconnect = true
      reserve = false
      sendMessage = false
    } else {
      if (state === callDefs.STATE_LOGIN) {
        login = true
        logout = false
        makeCall = false
        answer = true
        hold = true
        retrieve = true
        consult = true
        transfer = true
        conference = true
        reconnect = true
        notReady = false
        ready = false
        disconnect = true
        reserve = false
        sendMessage = false
      } else if (state === callDefs.STATE_READY) {
        login = true
        logout = false
        makeCall = false
        answer = true
        hold = true
        retrieve = true
        consult = true
        transfer = true
        conference = true
        reconnect = true
        notReady = false
        ready = true
        disconnect = true
        reserve = false
        sendMessage = false
      } else if (state === callDefs.STATE_NREADY) {
        login = true
        logout = false
        makeCall = false
        answer = true
        hold = true
        retrieve = true
        consult = true
        transfer = true
        conference = true
        reconnect = true
        notReady = false
        ready = false
        disconnect = true
        reserve = false
        sendMessage = false
      } else if (state === callDefs.STATE_DELIVERED_RECV) {
        login = true
        logout = false
        makeCall = true
        answer = false
        hold = true
        retrieve = true
        consult = true
        transfer = true
        conference = true
        reconnect = true
        notReady = true
        ready = true
        disconnect = true
        reserve = true
        sendMessage = false
      } else if (state === callDefs.STATE_DELIVERED_SEND) {
        login = true
        logout = false
        makeCall = true
        answer = true
        hold = true
        retrieve = true
        consult = true
        transfer = true
        conference = true
        reconnect = true
        notReady = true
        ready = true
        disconnect = false
        reserve = false
        sendMessage = false
      } else if (state === callDefs.STATE_DELIVERED_CONSULT) {
        login = true
        logout = false
        makeCall = true
        answer = true
        hold = true
        retrieve = true
        consult = true
        transfer = true
        conference = true
        reconnect = false
        notReady = true
        ready = true
        disconnect = false
        reserve = false
        sendMessage = false
      } else if (state === callDefs.STATE_ESTABLISHED) {
        login = true
        logout = false
        makeCall = true
        answer = true
        hold = false
        retrieve = true
        consult = false
        transfer = true
        conference = true
        reconnect = true
        notReady = true
        ready = true
        disconnect = false
        reserve = false
        sendMessage = false
      } else if (state === callDefs.STATE_ESTABLISHED_CONSULT) {
        login = true
        logout = false
        makeCall = true
        answer = true
        hold = true
        retrieve = true
        consult = true
        transfer = false
        conference = false
        reconnect = false
        notReady = true
        ready = true
        disconnect = false
        reserve = false
        sendMessage = false
      } else if (state === callDefs.STATE_HOLD) {
        login = true
        logout = false
        makeCall = true
        answer = true
        hold = true
        retrieve = false
        consult = true
        transfer = true
        conference = true
        reconnect = true
        notReady = true
        ready = true
        disconnect = true
        reserve = false
        sendMessage = false
      } else if (state === callDefs.STATE_CONFERENCED) { // 3자통화
        login = true
        logout = false
        makeCall = true
        answer = true
        hold = true
        retrieve = true
        consult = true
        transfer = true
        conference = true
        reconnect = true
        notReady = true
        ready = true
        disconnect = false
        reserve = false
        sendMessage = true
      } else if (state === callDefs.STATE_SERVICE_INITIATED) {
        login = true
        logout = false
        makeCall = true
        answer = true
        hold = true
        retrieve = true
        consult = true
        transfer = true
        conference = true
        reconnect = true
        notReady = true
        ready = true
        disconnect = false
        reserve = false
        sendMessage = false
      } else if (state === callDefs.STATE_ORIGINATED_COUNT1) {
        login = true
        logout = false
        makeCall = true
        answer = true
        hold = true
        retrieve = true
        consult = true
        transfer = true
        conference = true
        reconnect = true
        notReady = true
        ready = true
        disconnect = false
        reserve = true
        sendMessage = false
      } else if (state === callDefs.STATE_ORIGINATED_COUNT2) {
        login = true
        logout = false
        makeCall = true
        answer = true
        hold = true
        retrieve = true
        consult = true
        transfer = true
        conference = true
        reconnect = false
        notReady = true
        ready = true
        disconnect = false
        reserve = false
        sendMessage = false
      }
    }

    // 사용자 버튼 제어
    if (state !== callDefs.STATE_LOGOUT) {
      store.commit('changeBtnStatus', {
        logout,
        login,
        ready,
        notReady,
        hold,
        retrieve,
        consult,
        transfer,
        conference,
        reconnect,
        makeCall,
        answer,
        disconnect,
        reserve,
        sendMessage
      })
    }
  }
}
const apiEvent = {
  /*****************************************************************************
   * FUNCTON NAME : EventProc()
   * DESCRIPTION  : CTI Server에서 수신한 이벤트 구조체 처리.
   * INPUT        : CTI Server에서 수신한 이벤트 구조체
   * OUTPUT       : P_API 구조체
   /*****************************************************************************/
  EventProc: (rcvData) => {
    execModule('EventProc', rcvData)
  },
  removeLocalStorage: () => {
    if (!isKT()) { netDialApi.initIsLogin() }
    localStorage.removeItem('call-details-info')
  },
  startMonitor: (telNumber) => {
    if (isKT()) {
      store.commit('changeIsCallConnecting', false)
      const callDetailsInfo = getLocalStorage()
      if (callDetailsInfo) {
        klCnsAPI.setCallInfo(callDetailsInfo)
      }
      // FIXME: 불필요한 초기화 로직 확인
      // else {
      //   klCnsAPI.initCallID()
      // }

      klCnsAPI.KlStartMonitor()
    } else {
      store.commit('changeIsCallConnecting', false)
      const callDetailsInfo = getLocalStorage()
      if (callDetailsInfo) {
        netDialApi.setCallInfo(callDetailsInfo)
      } else {
        netDialApi.initCallID()
      }

      if (telNumber) netDialApi.ndMonitorDevice(telNumber, 0, 0, 0, 0, 0, '0')
    }
  },
  fetchAgentList: () => {
    netDialApi.ndGetGroupAgentList('99999', '*', '*', '*', '*')
  },
  loginCall: (callLoginId) => {
    if (isKT()) {
      setAgentState('AM_LOG_IN')
      const status = callStatus.state.callAgentStatus

      if (status) {
        if (status === '待機') {
          setTimeout(() => setAgentState('AM_READY'), 1000)
        } else if (status !== '通話中' && status !== '後処理中') {
          eventBus.$emit('user-status-change', status)
        }
      } else {
        setAgentState('AM_LOG_IN', callLoginId)
        callStatus.mutations.changeCallAgentStatus(callStatus.state, '相談準備')
      }
    } else {
      setAgentState('AM_LOG_IN', callLoginId)
      const status = callStatus.state.callAgentStatus

      if (status) {
        if (status === '待機') {
          setAgentState('AM_READY', callLoginId)
        } else if (status === '後処理中') {
          setAgentState('AM_WORK_NOT_READY', callLoginId)
        } else if (status !== '通話中') {
          eventBus.$emit('user-status-change', status)
        }
      } else {
        setAgentState('AM_NOT_READY', callLoginId, '09')
        logReport.write(`[CHANGE-AGENT]相談準備`)
        callStatus.mutations.changeCallAgentStatus(callStatus.state, '相談準備')
      }

      netDialApi.eventTimer()
    }
  },
  getSelfMonitor: () => {
    netDialApi.ndGetCenterStatus()
  },
  makeCall: (number, reception) => {
    isKT() ? klCnsAPI.KlExternalCall(number.slice(1), reception) : netDialApi.ndMakeCall(number, reception, 0)
  },
  answerCall: () => {
    isKT() ? klCnsAPI.KlAnswer() : netDialApi.ndAnswerCall()
  },
  holdCall: () => {
    isKT() ? klCnsAPI.KlHold(true) : netDialApi.ndHoldCall()
  },
  closeCall: (callLoginId) => {
    setAgentState('AM_LOG_OUT', callLoginId)
  },
  holdCancel: () => {
    isKT() ? klCnsAPI.KlHold(false) : netDialApi.ndRetrieveCall()
  },
  endCall: () => {
    isKT() ? klCnsAPI.KlHangup() : netDialApi.ndClearConnection()
  },
  transferCancel: () => {
    klCnsAPI.KlTransferCancel()
  },
  reConnectCall: () => {
    netDialApi.ndReconnectCall()
  },
  transferCall: () => {
    isKT() ? klCnsAPI.KlTransferCancel() : netDialApi.ndTransferCall()
  },
  setAgentState: (agentMode, callLoginId, subStatus) => {
    isKT() ? klCnsAPI.KlAgentStatus(callDefs.AgentMode[agentMode] || agentMode, subStatus) : netDialApi.ndSetAgentState(callDefs.AgentMode[agentMode] || agentMode, callLoginId, '', '', subStatus || '')
  },
  consultationCall: (telNumber, userInfo, len) => {
    isKT() ? klCnsAPI.KlTransfer('a', telNumber) : netDialApi.ndConsultationCall(telNumber, userInfo, len)
  },
  conferenceCall: () => {
    netDialApi.ndConferenceCall()
  },
  spyCall: (extension, option) => {
    klCnsAPI.KlSpyCall(extension, option)
  }
}

// const apiEventKT = {
//   startMonitor: (telNumber) => {
//     store.commit('changeIsCallConnecting', false)
//     const callDetailsInfo = getLocalStorage()
//     if (callDetailsInfo) {
//       klCnsAPI.setCallInfo(callDetailsInfo)
//     }
//     // FIXME: 불필요한 초기화 로직 확인
//     // else {
//     //   klCnsAPI.initCallID()
//     // }
//
//     klCnsAPI.KlStartMonitor()
//   },
//   loginCall: (callLoginId) => {
//     setAgentState('AM_LOG_IN')
//     const status = callStatus.state.callAgentStatus
//
//     if (status) {
//       if (status === '대기') {
//         setTimeout(() => setAgentState('AM_READY'), 1000)
//       } else if (status !== '통화중' && status !== '후처리중') {
//         eventBus.$emit('user-status-change', status)
//       }
//     } else {
//       setAgentState('AM_LOG_IN', callLoginId)
//       callStatus.mutations.changeCallAgentStatus(callStatus.state, '상담준비')
//     }
//   },
//   makeCall: (number, serviceNumber) => {
//     klCnsAPI.KlExternalCall(number.slice(1), serviceNumber)
//   },
//   answerCall: () => {
//     klCnsAPI.KlAnswer()
//   },
//   setAgentState: (agentMode, callLoginId, subStatus) => {
//     klCnsAPI.KlAgentStatus(callDefs.AgentMode[agentMode] || agentMode, subStatus)
//   }
// }

const eventList = util.mergeObject(common, apiEvent)
export default eventList

function setAgentState (agentMode, callLoginId, subStatus) {
  if (isKT()) {
    klCnsAPI.KlAgentStatus(callDefs.AgentMode[agentMode] || agentMode, subStatus)
  } else {
    netDialApi.ndSetAgentState(callDefs.AgentMode[agentMode] || agentMode, callLoginId, '', '', subStatus || '')
  }
}



// WEBPACK FOOTER //
// ./src/util/call/apiEvent.js